// extracted by css-extract-rspack-plugin
export default {"referBox":"referBox-Ai56ln"};